'use client';

import
  SectionLayout
from '@/app/ui/section-layout';

import
  ServiceCard
from '@/app/ui/services/service-card';

import {
  serviceCards
} from '@/app/data/services';

export default function ServicesSection() {

  return (
    <SectionLayout
      label="Services"
      heading="From Grade 1 to postgraduate - expert tutoring, application support, and career guidance for every stage of your academic journey."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {serviceCards.map((service) => (
          <ServiceCard key={service.title} {...service} />
        ))}
      </div>
    </SectionLayout>
  );
}
